import './style.css';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import SearchField from '../SearchField';
import BudgetButton from '../BudgetButton';
import Sidebar from '../Sidebar';
import { FULL_PRODUCTS } from '../../data/Products.js';
import {scrollToContact} from '../../assets/scroll';
import logoFacebook from '../../assets/images/facebook-logo.png';
import logoInstagram from '../../assets/images/instagram-logo.png';
import iconBurger from '../../assets/icons/icon-burger.svg';
import logo from '../../assets/icons/logo.svg';

function Navbar(){
    const [showSidebar, setShowSidebar] = useState(false);
    function handleClick(){
        setShowSidebar(!showSidebar);
    }
    return <nav>
        <Sidebar handleClick={handleClick} isOpened={showSidebar}/>
        <div className="top-header">
            <img className="icon-burger" src={iconBurger} onClick={()=>setShowSidebar(!showSidebar)}/>
            <Link to="/"><img className="top-header-logo" src={logo}/></Link>
            <div className="top-header-right">
                <SearchField />
                <h2>Materiales para la construcción</h2>
            </div>
        </div>
        <ul className="desktop-menu">
            <Link to="/"><li className="desktop-menu-item">Inicio</li></Link>
            <li className="desktop-menu-item" onClick={scrollToContact} style={{cursor: 'pointer'}}>La Empresa/Contacto</li>
            <li className="products desktop-menu-item"><Link to="/productos">Productos</Link>
                <ul className="products-list">
                    {FULL_PRODUCTS.map(item => <Link to={`/productos/${item.id}`}><li  className="product-list-item">{item.title}</li></Link>)}
                </ul>
            </li>
            <Link to="/consejos"><li className="desktop-menu-item">Consejos</li></Link>
            <li className="desktop-menu-item"><Link to="/varios">Varios</Link></li>
            <li className="desktop-menu-item rrss">    
                <a href="https://www.facebook.com/todobolsonsas/" target="_blank"><img src={logoFacebook} alt="facebook" width="20"/></a>
                <a href="https://www.instagram.com/todobolson/" target="_blank"><img src={logoInstagram} alt="instagram" width="20"/></a>
            </li>
            <li className="desktop-menu-item"><BudgetButton /></li>
        </ul>   
    </nav>
}

export default Navbar;